const headersSupported = "Headers" in window;
const globalHeaders = {};
/**
 * A decorator service over fetch that encodes the url and adds global headers on each request.
 * You can set the global headers via AjaxService.configure, e.g.
 *  AjaxService.configure(headers => {
 *      headers["Authorization"] = localStorage.getItem("sbtech_token");
 *      headers["X-Userinfo"] = JSON.stringify({ employeeId: 3 });
 *  });
 * */
export class AjaxService {
    static configure(configAction) {
        configAction(globalHeaders);
    }
    /**
     * Sends a request via fetch. The url will be encoded for you so you must not pass an already encoded value.
     * @param url - The non-encoded url.
     * @param options - The request options.
     */
    send(url, options = {}) {
        this.addGlobalHeaders(options);
        return fetch(encodeURI(url), options);
    }
    addGlobalHeaders(options) {
        if (headersSupported && options.headers instanceof Headers) {
            throw new Error("send(): headers via Headers class is not supported, use the plain object overload instead");
        }
        else if (Array.isArray(options.headers)) {
            throw new Error("send(): headers via array of string arrays is not supported, use the plain object overload instead");
        }
        options.headers = Object.assign(Object.assign({}, globalHeaders), options.headers);
    }
}
//# sourceMappingURL=AjaxService.js.map